module.exports = __webpack_public_path__ + "static/media/place.5ebbf98f.png";